<div class="margin-bottom-10">
	<ngx-skeleton-loader [theme]="{ width: '300px', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
</div>
<ngx-skeleton-loader [theme]="{ width: '500px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>

<!-- Tabs -->
<div class="row margin-vertical-30">
	<div *ngFor="let table of TABLES_ON_TAB" class="col-4">
		<ngx-skeleton-loader [theme]="{ width: '200px', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
	</div>
</div>

<table cellspacing="0" cellpadding="0">
	<thead>
		<tr>
			<th class="text-align-left">
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-left">
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '90px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '30px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '100px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
			<th class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '100px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let rows of GHOST_ROWS">
			<td>
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td>
				<ngx-skeleton-loader [theme]="{ width: '200px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '30px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '50px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
			<td class="text-align-right">
				<ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
			</td>
		</tr>
	</tbody>
</table>
<!-- Pagination -->
<div class="row">
	<div class="col-3">
		<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
	</div>
	<div class="col-15"></div>
	<div class="col-6 text-align-right">
		<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
	</div>
</div>

<!-- Disclosure -->
<div class="margin-vertical-30">
	<ngx-skeleton-loader count="4" [theme]="{ width: '100%', 'margin-bottom': '10px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
</div>
